export default {
  header_main: 'รับ/ปฏิเสธ สิ่งส่งตรวจ',
  patient_info: 'ข้อมูลผู้ป่วย',
  receiveLab: 'รับสิ่งส่งตรวจ',
  rejectLab: 'ปฏิเสธสิ่งส่งตรวจ',
  returnLab: 'คืนสถานะ',
  printOrderReport: 'พิมพ์ใบสั่งตรวจ',
  printSticker: 'พิมพ์สติ๊กเกอร์',
  Laboratory: 'ห้องปฏิบัติการ',
  OrderItemId: 'รหัสสิ่งส่งตรวจ',
  OrderItemDesc: 'รายการตรวจ',
  cust_name: 'หน่วยงาน',
  OrderItemLaboratoryName: 'ห้องปฎิบัติการ',
  OrderId: 'เลขที่สั่งตรวจ',
  IdCard: 'เลขที่บัตรประชาชน',
  OrderItemSpecimenType: 'ชนิดสิ่งส่งตรวจ',
  OrderItemPrice: 'ราคา (บาท)',
  lab_item_status: 'สถานะ',
  lis_sid: 'เลขสิ่งส่งตรวจ',
  OrderItemRemark: 'หมายเหตุ',
  remark: 'หมายเหตุ',
  PackageNo: 'เลขที่บรรจุภัณฑ์',
  PatientName: 'ชื่อคนไข้',
  HN: 'HN',
  prefix: 'คำนำหน้า',
  fullname: 'ชื่อ-นามสกุล',
  firstname: 'ชื่อ',
  middlename: 'ชื่อกลาง',
  lastname: 'นามสกุล',
  birthday: 'วันเกิด',
  age: 'อายุ',
  sex: 'เพศ',
  user_created: 'แพทย์ผู้สั่งตรวจ',
  date_created: 'วันที่สั่งตรวจ',
  date_send: 'วันที่ส่งตรวจ',
  date_receive: 'วันที่รับสิ่งส่งตรวจ',
  date_result: 'วันที่รายงานผล',
  collectionDate: 'วันที่เก็บสิ่งส่งตรวจ',
  status: 'สถานะ',
  hospitalLabNo: 'เลขที่สิ่งส่งตรวจ',
  paymentType: 'ประเภทการชำระเงิน',
  project: 'โครงการ',
  pleaseSpecifyRejectReason: 'ระบุเหตุผลการปฏิเสธสิ่งส่งตรวจ',
  pleaseSendLabFirst: 'กรุณาทำการส่งตรวจก่อน',
  pleaseSelectData: 'กรุณาเลือกข้อมูล',
  pleaseSelectSpecimenToReceive: 'กรุณาเลือกสิ่งส่งตรวจที่ต้องการรับ',
  pleaseSelectSpecimenToReturn: 'กรุณาเลือกสิ่งส่งตรวจที่ต้องการคืนค่า',
  warningReceiveAgain: 'รายการสั่งตรวจที่รับแล้วหรือถูกปฏิเสธ ไม่สามารถรับซ้ำได้ กรุณาปฏิเสธสิ่งส่งตรวจเก่าก่อน',
  warningReceiveReject: 'ไม่สามารถรับสิ่งส่งตรวจที่ถูกปฏิเสธได้',
  pleaseSelectNotReceive: 'กรุณาเลือกเฉพาะสิ่งส่งตรวจที่ยังไม่ได้รับ',
  pleaseSelectReject: 'กรุณาเลือกสิ่งส่งตรวจที่ต้องการปฏิเสธ',
  is_urgent: 'ขอผลด่วน',
  is_get_back: 'คืนสิ่งส่งตรวจ',
  statusObj: {
    OP: 'ขอตรวจ',
    COLLECTION: 'รอรับสิ่งส่งตรวจ',
    RECEIVEDALL: 'รับสิ่งส่งตรวจเเล้ว',
    FIRSTAPPROVE: 'รายงานผล',
    LASTAPPROVE: 'อนุมัติผล',
    CA: 'ยกเลิกส่งตรวจ',
    labApprove: 'ส่งผลแล้ว',
    labNotApprove: 'รอส่งผล',
    return: 'คืนสถานะ',
    reject: 'ปฏิเสธสิ่งส่งตรวจ',
    receive: 'รับสิ่งส่งตรวจ',
    cancelSpecimen: 'ยกเลิกรายการตรวจ',
    receivedReject: 'รับและปฏิเสธสิ่งส่งตรวจแล้ว',
    receivedRejectSome: 'รับและปฏิเสธสิ่งส่งตรวจบางรายการ',
    rejected: 'ปฏิเสธสิ่งส่งตรวจแล้ว',
  },
  back: 'ย้อนกลับ',
  collectDate: 'วันที่เก็บสิ่งส่งตรวจ',
  rejectSpecimen: 'ปฏิเสธสิ่งส่งตรวจ',
  reason: 'เหตุการปฏิเสธ',
  note: 'หมายเหตุ',
  date: 'วันที่',
  userHist: 'ผู้ลงผล',
  paymentStatus: 'สถานะการชำระเงิน',
  labStatus: 'สถานะการสั่งตรวจ',
  labApproveStatus: 'สถานะการส่งผล',
  receivedUser: 'ผู้รับ/ปฏิเสธสิ่งส่งตรวจ',
  packageNo: 'Package No',
  pleaseGoPayment: 'ไม่สามารถรับสิ่งส่งตรวจได้ เนื่องจากยังไม่มีการยืนยันการชำระเงิน',
  code: 'รหัส',
  desc: 'รายละเอียด',
  rejectUser: 'ผู้รับบริการ/รับเรื่อง',
  cancelOrderItem: 'ยกเลิกรอคืนเงิน',
  confirmReturnSpecimenTitle: 'คุณต้องการคืนค่าสิ่งส่งตรวจหรือไม่?',
  confirmReceiveSpecimenTitle: 'คุณต้องการรับสิ่งส่งตรวจหรือไม่?',
  confirmCancelspecimenTitle: 'คุณต้องการยกเลิกรายการตรวจหรือไม่?',
  errorReturnSpecimen: 'ไม่สามารถคืนค่าสิ่งส่งตรวจที่มีสถานะ ยังไม่รับสิ่งส่งตรวจ หรือ ยกเลิกรายการตรวจ ได้',
  warningRejectAgain: 'รายการสั่งตรวจที่ถูกปฏิเสธแล้ว ไม่สามารถปฏิเสธซ้ำได้',
  search: 'ค้นหา',
  enterReason: 'กรุณาระบุเหตุผล',
  pleaseCancalApproveFirst: 'กรุณา cancel approve ก่อน',
  returnInvoidError: 'ไม่สามารถคืนค่ารายการที่มี Invoice ได้',
  errorCancelSpecimenThatAlreadyCancel: 'ไม่สามารถยกเลิกรายการที่เคยยกเลิกไปแล้วได้',
  pleaseSelectSpecimenToResent: 'กรุณาเลือกรายการที่ต้องการ Resent',
  resentGatewaySuccess: 'Resent เรียบร้อยเเล้ว',
  receiptGenerated: 'ออกใบเสร็จแล้ว',
  receiptSent: 'ส่งใบเสร็จแล้ว',
  uploadingFile: 'กรุณารอสักครู่กำลังอัพโหลดไฟล์',
  uploadSuccess: 'อัพโหลดเรียบร้อยแล้ว',
  specimenTypeId: 'Specimen Type ID',
}
